/* Presentation only: all cart requests and variant changes remain native theme behavior. */
class OrStickyBuy extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.source = document.getElementById(this.dataset.target);
    this.owner = this.closest('product-info');
    if (!this.source || !this.owner) return;
    this.onUpdate = () => {
      const current = document.getElementById(this.dataset.target);
      if (!current) { this.hidden = true; return; }
      const rect = current.getBoundingClientRect();
      const blocked = document.querySelector('cart-drawer.active, dialog[open], .product-media-modal[open], .search-modal[open]') || document.body.className.includes('overflow-hidden');
      this.hidden = !matchMedia('(max-width: 749px)').matches || rect.bottom >= 0 || !!blocked;
      const price = this.owner.querySelector('[id^="price-"] .price__container');
      const visiblePrice = price?.querySelector(this.owner.querySelector('[id^="price-"] .price--on-sale') ? '.price-item--sale' : '.price__regular .price-item');
      const dest = this.querySelector('[data-sticky-price]');
      if (visiblePrice && dest && dest.textContent !== visiblePrice.textContent.trim()) dest.textContent = visiblePrice.textContent.trim();
      const button = this.querySelector('button');
      const disabled = this.dataset.mode === 'submit' && (current.disabled || current.getAttribute('aria-disabled') === 'true');
      if (button.disabled !== disabled) button.disabled = disabled;
    };
    this.querySelector('button').addEventListener('click', () => {
      const current = document.getElementById(this.dataset.target);
      if (!current) return;
      const form = current.closest('form');
      if (this.dataset.mode === 'submit' && form && !current.disabled && current.getAttribute('aria-disabled') !== 'true') {
        // Uses the original product form, including current quantity and line-item properties.
        form.requestSubmit(current);
      } else {
        const target = this.owner.querySelector('variant-selects') || current;
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        (target.querySelector('input,select,button') || current).focus({ preventScroll: true });
      }
    }, { signal: this.abort.signal });
    addEventListener('scroll', this.onUpdate, { passive: true, signal: this.abort.signal });
    addEventListener('resize', this.onUpdate, { signal: this.abort.signal });
    this.observer = new MutationObserver(this.onUpdate);
    this.observer.observe(this.owner, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled','aria-disabled'] });
    this.bodyObserver = new MutationObserver(this.onUpdate);
    this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    this.onUpdate();
  }
  disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.bodyObserver?.disconnect(); }
}
class OrBookingBar extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.update = () => {
      const areas = [...document.querySelectorAll('.or-treatment-product')];
      const visible = areas.some(n => { const r=n.getBoundingClientRect(); return r.top < innerHeight && r.bottom > 0; });
      const hero = document.querySelector('.or-treatment-hero');
      const blocked = document.body.className.includes('overflow-hidden') || [...document.querySelectorAll('cart-drawer.active, dialog[open], [aria-modal="true"]:not([hidden])')].some(node => {
        if (node.closest('details:not([open])')) return false;
        const rect = node.getBoundingClientRect();
        const style = getComputedStyle(node);
        return style.visibility === 'visible' && style.opacity !== '0' && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
      });
      this.hidden = !areas.length || !matchMedia('(max-width: 749px)').matches || visible || !hero || hero.getBoundingClientRect().bottom > 0 || !!blocked;
    };
    addEventListener('scroll', this.update, { passive:true, signal:this.abort.signal });
    addEventListener('resize', this.update, { signal:this.abort.signal });
    this.observer=new MutationObserver(this.update);this.observer.observe(document.body,{attributes:true,attributeFilter:['class']});this.update();
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
}
if (!customElements.get('or-sticky-buy')) customElements.define('or-sticky-buy', OrStickyBuy);
if (!customElements.get('or-booking-bar')) customElements.define('or-booking-bar', OrBookingBar);
